import React, { useEffect, useState } from "react";
import { SWIREPAY_URL } from "../../appconstants";
import ErrorPage from "../../components/error";
import { getStripeRedirectUrl } from "../../api";

type Props = {}

const Onboarding = (props: Props) => {
    const { location: { pathname } } = props;
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const getData = async () => {
        const path = pathname.replace('/us-boarding/', '/us-boarding-link/')
        try {
            const value = await getStripeRedirectUrl(path);
            console.log(value, 'value');
            if (value && value.entity && value.entity.url) {
                window.location = value.entity.url;
            } else {
                window.location = SWIREPAY_URL;
            }
        } catch (e) {
            setErrorMessage(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    if (loading) {
        return <center><div style={{ marginTop: '25%' }} className="spinner-border text-muted mr-4" /></center>
    }

    return (
        <>
            {
                errorMessage ? (
                    <ErrorPage
                        heading={'Oops!'}
                        body={'Something went wrong and we are unable to serve you at this moment'}
                        url={SWIREPAY_URL}
                    />
                ) : (
                    <div className="ml-4 mt-4">
                        Redirecting....
                    </div>
                )
            }
        </>
    )
};

export default Onboarding;
